export class PitrBackupPolicyPlan {
    'resourceType';
    'backupSchedules';
    'pitrSchedules';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "PitrBackupResourceType",
            "format": ""
        },
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<StandardBackupSchedules>",
            "format": ""
        },
        {
            "name": "pitrSchedules",
            "baseName": "pitrSchedules",
            "type": "Array<PitrBackupSchedules>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PitrBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
